import React from 'react';
import classnames from 'classnames';
import Text from '../../../../../global/text/text';
import DefaultButton from '../../../../../global/default-button/default-button';
import './passport-field.scss';

type IProps = {
    labelText?: string;
    rowText?: string;
    buttonText?: string;
    onClick?: () => void;
    children?: React.ReactNode;
    disabled?: boolean;
    className?: string;
    rowTextPrefix?: React.ReactNode;
    rowTextSuffix?: React.ReactNode;
    additionalField?: React.ReactNode;
    additionalRowText?: string;
    buttonDataTestId?: string;
};

const PassportField = (props: IProps) => {
    const {
        labelText,
        buttonText,
        onClick,
        rowText,
        children,
        disabled = false,
        className,
        rowTextPrefix,
        rowTextSuffix,
        additionalField,
        additionalRowText,
        buttonDataTestId
    } = props;

    return (
        <div className={`passport-field-container w-100 ${className}`}>
            {labelText && <Text message={labelText} className='passport-field-container__label'/>}
            {additionalField && <div className='passport-field-container__additional-field'>{additionalField}</div>}
            <div
                className={classnames({
                    'passport-field-container__row': !!rowText,
                    'passport-field-container__section': !!labelText
                })}
            >
                { rowText && <span className="passport-field-container__row-text-wrapper">
                    {rowTextPrefix && <span className="passport-field-container__row-text-prefix">{rowTextPrefix}</span>}
                    <span className='passport-field-container__row-text'>
                        {rowText}
                        { additionalRowText && <Text message={additionalRowText} className='passport-field-container__additional-row-text'/> }
                    </span>
                    {rowTextSuffix}
                </span>
                }
                {children}
                {buttonText && <DefaultButton
                    disabled={disabled}
                    text={buttonText}
                    modifier='slim'
                    onClick={onClick}
                    dataTestId={buttonDataTestId}
                />}
            </div>
        </div>
    );
};

export { PassportField };
